import { useState, useEffect } from "react"
import { H3 } from "components/ui/typography/titles/Titles"
import { useObjectCategoryDrawerStore } from "store/configuration.store"
import { InModelTrain } from "components/ui/InModelTrain/InModelTrain"
import { ObjectTypeTooltip } from "components/ui/ObjectTypeTooltip/ObjectTypeTooltip"
import { Checkbox } from "components/ui/checkbox/Checkbox"
import { useMessage } from "hooks/message.hook"
import { CloseIcon } from "components/ui/icons/close/CloseIcon"
import { useIncludeInProcessing } from "hooks/api/objectsCategories/objectsCategories.hook"
import style from "./ObjectCategoryInfo.module.scss"

const { objectCategory, grid, objectType, label, closeIcon, closeButton, topWrapper, gridWrapper } = style

export const ObjectCategoryInfo = () => {
	const { objectCategoryStore, triggerDrawer } = useObjectCategoryDrawerStore()
	const { error: errorMessage } = useMessage()
	const { mutate: includeInProcessingMutate, isPending } = useIncludeInProcessing()

	const [isChecked, setIsChecked] = useState(!!objectCategoryStore.inProcessingResult)

	useEffect(() => {
		setIsChecked(!!objectCategoryStore.inProcessingResult)
	}, [objectCategoryStore.id, objectCategoryStore.inProcessingResult])

	const inProcessingResultHandle = (includedInProcessing: boolean, id: number) => {
		const previous = isChecked
		setIsChecked(includedInProcessing)
		includeInProcessingMutate(
			{ includedInProcessing, categoryId: id },
			{
				onError: () => {
					setIsChecked(previous)
					errorMessage("Something went wrong, please try again later")
				},
			},
		)
	}

	return (
		<div className={objectCategory}>
			<div className={topWrapper}>
				<H3>{objectCategoryStore.name}</H3>
				<button className={closeButton} onClick={() => triggerDrawer()}>
					<CloseIcon className={closeIcon} />
				</button>
			</div>
			<div className={gridWrapper}>
				<div className={grid}>
					<div className={label}>Object type</div>
					<div className={objectType}>
						{objectCategoryStore.type === "regular_object" ? (
							"regular object"
						) : (
							<ObjectTypeTooltip type={objectCategoryStore.type} />
						)}
					</div>
					<div className={label}>Model label</div>
					<div>{objectCategoryStore.label}</div>
					<div className={label}>In model</div>
					<div>
						<InModelTrain inModelTrain={objectCategoryStore.inModelTrain} />
					</div>
					<div className={label}>Object count</div>
					<div>{objectCategoryStore.objectCount}</div>
					{objectCategoryStore.inModelTrain ? (
						<>
							<div className={label}>Processing</div>
							<div>
								<Checkbox
									checked={isChecked}
									disabled={isPending}
									onChange={(e) => {
										if (objectCategoryStore.id) {
											inProcessingResultHandle(e.target.checked, objectCategoryStore.id)
										}
									}}
								/>
							</div>
						</>
					) : null}
				</div>
			</div>
		</div>
	)
}
